import React from 'react'
import { Skeleton } from '@chakra-ui/react'
import { generateArrayWithRandomKeys } from '@/shared/utils'

export const HelpRecommendedLoader = ({ ...props }) => (
  <>
    {generateArrayWithRandomKeys(4).map((subKey: number) => (
      <Skeleton
        key={subKey}
        maxWidth={'100%'}
        height='55px'
        width='100%'
        marginY={'24px'}
        {...props}
      />
    ))}
  </>
)
